import React from "react";

import "./query-card.scss";

const QueryCard = ({ title, ticket, date, status }) => {
  return (
    <div className="query-card-section">
      <div className="left-content">
        <label className="title">{title}</label>
        <label className="ticket-num">Ticket No: {ticket}</label>
        <label className="date">{date}</label>
      </div>
      <div className="right-content">
        <label className={status === "Active" ? "active" : "closed"}>
          {status}
        </label>
      </div>
    </div>
  );
};

export default QueryCard;
